__turbopack_context__.v({
  "menu": "CommitmentsDropdown-module__e0Ur1q__menu",
  "menuListItem": "CommitmentsDropdown-module__e0Ur1q__menuListItem",
});
